import { render, staticRenderFns } from "./HeaderMegamenuDesktop.vue?vue&type=template&id=6c4f7859"
import script from "./HeaderMegamenuDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderMegamenuDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports